// Trailing rolling-window averages for time-series sparklines.
// Days early in the range (index < windowSize - 1) average over the
// available partial window rather than rendering null — otherwise the
// start of every chart would be blank for the first 6 days.

export function rollingAverage(
  values: Array<number | null>,
  windowSize: number,
): Array<number | null> {
  return values.map((_, i) => {
    const start = Math.max(0, i - windowSize + 1);
    let sum = 0;
    let count = 0;
    for (let j = start; j <= i; j++) {
      const v = values[j];
      if (v !== null && v !== undefined && Number.isFinite(v)) {
        sum += v;
        count += 1;
      }
    }
    return count === 0 ? null : sum / count;
  });
}
